export default __webpack_public_path__ + "static/media/assessment_icon.b04d9d55.svg";